<template lang="html">
  <i-btn
    icon="mdi-plus-circle"
    color="success"
    @click="$emit('click', $event)"/>
</template>

<script>
import IconButton from './IconButton'

export default {
  components: {
    'i-btn': IconButton
  }
}
</script>

<style lang="css" scoped>
</style>
